import React, { useState, useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import PageTitle from "components/PageTitle";
import { userTypesOther } from "config/constants";
import OtherRegistrationForm from "./OtherRegistrationForm";
import { SITE_KEY } from "config/recaptcha";

const OtherRegistration = (props) => {
  const slug = props?.match?.params?.slug;

  const [title, setTitle] = useState("");

  const getTitle = (slug) => {
    const item = userTypesOther.find((item) => item.slug === slug);
    return item?.title || "";
  };

  useEffect(() => {
    const title = getTitle(slug);
    setTitle(title);
  }, [slug]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
      <div className="page-body">
        <PageTitle align="center" isBackButton={true}>
          {title}
        </PageTitle>

        <div className="content-container">
          <div className="container">
            <OtherRegistrationForm slug={slug} />
          </div>
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default OtherRegistration;
